import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ToolTip from 'core/components/Tooltip';
import {
  SidePanelComponentProps,
} from 'pages/Dashboard/contexts/sidePanel';
import {
  OrgPCCActivationStatus,
} from 'dtos/orgPCCActivationStatus';
import PCCSettingsForm, {
  getPCCSettingsCopy,
} from 'views/EMR/Settings/PCC/PCCSettingsForm';
import {
  useGetPCCActivationSettings,
} from 'views/EMR/hooks/pcc';
import PopulateUrl from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/PCC/PCCLearnMoreLink';

export const PCC_LEARN_MORE_URL = 'https://knowledge.populateemr.com/populate-continuous-care-pcc';

export default function PCCActivationSettingsPanel({
  onClose,
}: SidePanelComponentProps) {
  const { data: activationSettings } = useGetPCCActivationSettings();
  const isActivated = activationSettings?.activationStatus
    === OrgPCCActivationStatus.Active;
  const panelCopy = getPCCSettingsCopy(isActivated);

  return (
    <div className="flex h-full w-[40rem] flex-col overflow-hidden bg-white">
      <div className="flex shrink-0 items-center justify-between border-b border-gray-200 px-4 py-3">
        <div className="flex items-center gap-2">
          <h3 className="text-xl font-semibold text-gray-900">{panelCopy.title}</h3>
          {isActivated && (
            <PopulateUrl url={PCC_LEARN_MORE_URL} label="Learn more" />
          )}
        </div>
        <ToolTip title="Close">
          <IconButton
            aria-label="Close"
            size="small"
            type="button"
            onClick={onClose}
          >
            <CloseIcon className="!h-5 !w-5 !text-inherit" />
          </IconButton>
        </ToolTip>
      </div>
      <PCCSettingsForm className="min-h-0 flex-1" onClose={onClose} />
    </div>
  );
}
